import { baseApi } from './base';
import type { Event, CreateEventRequest } from '@/types/event';

export const eventService = {
  async createEvent(data: CreateEventRequest): Promise<Event> {
    return baseApi.request<Event>('/events/', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async getEvents(params: { lawsuit?: string; start_date?: string; end_date?: string } = {}): Promise<{ results: Event[] }> {
    const queryParams: Record<string, string> = {};
    if (params.lawsuit) queryParams.lawsuit = params.lawsuit;
    if (params.start_date) queryParams.start_date = params.start_date;
    if (params.end_date) queryParams.end_date = params.end_date;

    const query = new URLSearchParams(queryParams).toString();
    return baseApi.request<{ results: Event[] }>(`/events/?${query}`);
  },

  async updateEvent(id: string, data: Partial<Event>): Promise<Event> {
    return baseApi.request<Event>(`/events/${id}/`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async getEvent(id: string): Promise<Event> {
    return baseApi.request<Event>(`/events/${id}/`);
  },
};
